import React from 'react'

const Manual_requisiciones_solicitar = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Requisiciones - Solicitar una Requisición
        </h2>
        <iframe
          src="https://scribehow.com/embed/Requisiciones__Solicitar_una_Requisicion__fX1kJlZXRvWf9pFNR5glwg?as=scrollable"
          className="scribe-iframe-general-173"
          width="100%"
          height="9200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_requisiciones_solicitar
